import { schema } from 'normalizr';

const invitation = new schema.Entity('invitation');
const invitations = {
	content: [new schema.Entity('invitations')]
};

const InvitationSchemas = {
	INVITATIONS: invitations,
	INVITATION: invitation
};

export default InvitationSchemas;
